import React, { useState, useEffect, useRef } from 'react';

// Type-to-search dropdown. Props: value, options [{value,label,sub?}], onChange,
// placeholder, inputStyle (optional override). Filters as you type. `onCreate` (optional):
// when given, typing something that isn't in the list offers an "Add …" row that calls
// onCreate(text) — so a material/part that isn't on file can still be entered.
export default function SearchSelect({ value, options = [], onChange, onCreate, placeholder, inputStyle }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);
  useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const selected = options.find(o => String(o.value) === String(value));
  const ql = q.trim().toLowerCase();
  const list = options.filter(o => !ql || `${o.label} ${o.sub || ''}`.toLowerCase().includes(ql)).slice(0, 60);
  const exact = options.some(o => o.label.trim().toLowerCase() === ql);
  const showCreate = !!onCreate && !!ql && !exact;   // typed something new → offer to add it
  const inp = inputStyle || { width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 8, padding: '10px 12px', fontSize: 14, background: '#fff' };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        value={open ? q : (selected ? selected.label : '')}
        onChange={e => { setQ(e.target.value); if (!open) setOpen(true); }}
        onFocus={() => { setOpen(true); setQ(''); }}
        placeholder={selected ? selected.label : (placeholder || 'Search…')}
        style={inp} />
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 200, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 3, maxHeight: 260, overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.16)' }}>
          {list.map(o => (
            <div key={String(o.value)} onMouseDown={() => { onChange(o.value); setOpen(false); setQ(''); }}
              style={{ padding: '10px 12px', fontSize: 14, cursor: 'pointer', borderBottom: '1px solid #f3f4f6', background: String(o.value) === String(value) ? '#eff6ff' : '#fff' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; }}
              onMouseLeave={e => { e.currentTarget.style.background = String(o.value) === String(value) ? '#eff6ff' : '#fff'; }}>
              {o.label}{o.sub ? <span style={{ color: '#9ca3af', fontSize: 12 }}> · {o.sub}</span> : ''}
            </div>
          ))}
          {list.length === 0 && !showCreate && <div style={{ padding: '10px 12px', fontSize: 13, color: '#9ca3af' }}>No matches</div>}
          {showCreate && (
            <div onMouseDown={() => { onCreate(q.trim()); setOpen(false); setQ(''); }}
              style={{ padding: '10px 12px', fontSize: 14, cursor: 'pointer', fontWeight: 700, color: '#1e3a5f', background: '#eff6ff', borderTop: list.length ? '1px solid #e5e7eb' : 'none' }}>
              ➕ Add “{q.trim()}” as a new item
            </div>
          )}
        </div>
      )}
    </div>
  );
}
